"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onUserReady = exports.onConfigReady = exports.onAnalytics = exports.trigger = exports.on = exports.ON_ANALYTICS = exports.ON_CONFIG_READY = exports.ON_USER_LOGOUT = exports.ON_USER_READY = void 0;
const Store_1 = require("./Store");
exports.ON_USER_READY = 'USER_READY';
exports.ON_USER_LOGOUT = 'USER_LOGOUT';
exports.ON_CONFIG_READY = 'CONFIG_READY';
exports.ON_ANALYTICS = 'ANALYTICS';
const listeners = new Map();
const autoTriggerPayload = new Map();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const secureExecute = (callback, args = []) => {
    try {
        callback(...args);
    }
    catch (e) {
        // tslint:disable-next-line: no-console
        console.warn(`Error received while executing bus.trigger`, e);
    }
};
/**
 * Add a listener to the bus
 *
 * @param eventName
 * @param callback
 */
function on(eventName, callback) {
    if (!listeners.has(eventName)) {
        listeners.set(eventName, []);
    }
    listeners.get(eventName).push(callback);
    if (autoTriggerPayload.has(eventName)) {
        secureExecute(callback, [autoTriggerPayload.get(eventName), Store_1.store.dispatch]);
    }
}
exports.on = on;
/**
 * Trigger an event to the bus
 *
 * @param eventName
 * @param payload
 */
function trigger(eventName, payload = {}) {
    if (!listeners.has(eventName)) {
        return;
    }
    // Keep the payload in memory and automatically trigger those events
    // in the future once the listener is register
    if ([exports.ON_USER_READY, exports.ON_CONFIG_READY].includes(eventName)) {
        autoTriggerPayload.set(eventName, payload);
    }
    listeners.get(eventName).forEach((cb) => secureExecute(cb, [payload, Store_1.store.dispatch]));
}
exports.trigger = trigger;
function onAnalytics(callback) {
    return on(exports.ON_ANALYTICS, callback);
}
exports.onAnalytics = onAnalytics;
function onConfigReady(callback) {
    return on(exports.ON_CONFIG_READY, callback);
}
exports.onConfigReady = onConfigReady;
function onUserReady(callback) {
    return on(exports.ON_USER_READY, callback);
}
exports.onUserReady = onUserReady;
//# sourceMappingURL=Bus.js.map